import CardsList from "@/components/cardsList";
import { PlainHoverEffect } from "styles/hoverPresets";
import { K8S_GETTING_STARTED } from "./constants";

const Implementation = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 3 }}
      title={K8S_GETTING_STARTED.title}
      list={K8S_GETTING_STARTED.list}
      spacing={{ base: 8, md: 12 }}
      hoverEffect
      hover={PlainHoverEffect}
    />
  );
};

export default Implementation;
